import { styled } from "@mui/material/styles";

const StyledTasterMenu = styled("div")`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 0 16px;
  }

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

const StyledTasterMenuContent = styled("div")`
  width: 100%;
  box-sizing: border-box;
`;

const StyledTasterMainInfo = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 24px;
  box-sizing: border-box;

  & .taster-info__avatar {
    margin-bottom: 24px;
  }
`;

const StyledTasterMenuForm = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;
`;

const StyledTasterMenuStepBtnGroup = styled("div")`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 16px;
  bottom: 30px;
  box-sizing: border-box;
`;

export {
  StyledTasterMenu,
  StyledTasterMenuContent,
  StyledTasterMainInfo,
  StyledTasterMenuForm,
  StyledTasterMenuStepBtnGroup,
};
